
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chatgpt-api-playground-ui-for-beginners",
      function () {
        return require("private-next-pages/chatgpt-api-playground-ui-for-beginners.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chatgpt-api-playground-ui-for-beginners"])
      });
    }
  